import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Event } from 'epc-schema'
import { Navigation, Responsive, Search, Templates } from 'ui'
import { truncate } from 'utils'
import { usePaginatedEvents } from './usePaginatedEvents'
import { SecondaryDrawerPortal } from '../../AppNavigator/SecondaryDrawerPortal'

const { Navigator } = Templates

interface IUserProfileDetailParams {
  id: string
}

export const EventNavigationDrawer: React.FC = () => {
  const { drawerActive, drawerCompact } = useContext(
    Responsive.DrawerManagerContext
  )
  const { id } = useParams<IUserProfileDetailParams>()

  const {
    currentPage,
    handlePageClick,
    loading,
    pageCount,
    events,
    locationSearch,
    search,
    setQueryString,
    toggleFacet,
    humanizedAppliedFacets,
  } = usePaginatedEvents({ fetchPolicy: 'cache-first' })

  const renderContentItem = (event: Event) => (
    <Navigator.ContentItem
      key={event.id}
      label={truncate(event.name, 22)}
      hideAvatar
      labelStyle={{ fontSize: 14, lineHeight: 1.3 }}
      contentStyle={{ fontSize: 10, lineHeight: 1.3 }}
      content={truncate(event.description || '', 38)}
      to={`/admin/events/show/${event.id}${locationSearch}`}
      active={id === event.id}
    />
  )

  const contentItems = events?.map((p) => renderContentItem(p as Event))
  const handleClearFilter = (id: string) => {
    toggleFacet(id, 'remove')
  }

  return (
    <SecondaryDrawerPortal>
      <Navigator.Drawer
        hasSibling={drawerActive}
        hasCompactSibling={drawerCompact}
        theme="secondary"
        loading={loading}
      >
        <React.Fragment>
          <Navigator.Generic className="py-4">
            <Search.SearchControls
              facets={humanizedAppliedFacets}
              queryString={search.queryString ?? ''}
              onQuery={setQueryString}
              onRemoveFacet={handleClearFilter}
            />
          </Navigator.Generic>
          {contentItems}
          {loading ? null : (
            <Navigation.SimplePaginationBar
              onPageClick={handlePageClick({ historyPush: true })}
              currentPage={currentPage ?? 0}
              pageCount={pageCount ?? 0}
            />
          )}
        </React.Fragment>
      </Navigator.Drawer>
    </SecondaryDrawerPortal>
  )
}
